var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),(_vm.$routerHistory.canBack())?_c('i',{staticClass:"cubeic-back",on:{"click":_vm.back}}):_vm._e(),_c('div',{staticClass:"extend"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }